<template>
  <div class="min-h-32 flow-root">
    <LoadingCharacters class="float-left mr-6" />
    <AnimatedText
      class="body-1"
      :colors="['#3F55BF']"
      :translations="loadingMessages"
      wrap
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import AnimatedText from '~/components/AnimatedText/AnimatedText.vue'

import LoadingCharacters from '../LoadingCharacters/LoadingCharacters.vue'

import animatedTextTranslations from './AnimatedText.translations'
import { shuffleMessages } from './Loader.utils'

const i18n = useI18n()

const loadingMessages = shuffleMessages(
  Object.values(animatedTextTranslations).map((t) => i18n(t)),
)
</script>
